var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#10d49e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.06,
    y: 2.06,
    width: 115.87,
    height: 115.87,
    rx: 21.07,
    ry: 21.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.7,31.03H36.3c-4.36,0-7.9,3.54-7.9,7.9v47.4c0,4.36,3.54,7.9,7.9,7.9h47.4c4.36,0,7.9-3.54,7.9-7.9V38.93c0-4.36-3.54-7.9-7.9-7.9Zm-50.04,55.3V38.93c0-1.45,1.18-2.63,2.63-2.63h47.4c1.45,0,2.63,1.18,2.63,2.63v27.04l-11.81-11.81c-.49-.49-1.16-.77-1.86-.77s-1.37,.28-1.86,.77l-34.76,34.76c-1.33-.14-2.38-1.22-2.38-2.58Zm50.04,2.63H43.44l29.23-29.23,13.67,13.67v12.92c0,1.45-1.18,2.63-2.63,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.47,60c4.36,0,7.9-3.54,7.9-7.9s-3.54-7.9-7.9-7.9-7.9,3.54-7.9,7.9,3.54,7.9,7.9,7.9Zm0-10.53c1.45,0,2.63,1.18,2.63,2.63s-1.18,2.63-2.63,2.63-2.63-1.18-2.63-2.63,1.18-2.63,2.63-2.63Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconImage);
export default __webpack_public_path__ + "static/media/media-icon-image.2342ca87ebaed8d41736adde6e5560d6.svg";
export { ForwardRef as ReactComponent };